import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/layout/header-anon/index.tsx");
